import React, { useEffect, useState } from "react";
import { doc, onSnapshot} from "firebase/firestore";
import { db } from "../firebase";
import { useLocation } from "react-router-dom";

const StudentDetailsAll = () => {

    const location = useLocation();
    const [studentDetails, setStudentDetails] = useState([]);

    useEffect(() => {
  
        onSnapshot(doc(db, "admissionStudentList", location.state.studentId), (doc) => {
            let array=[]
            array.push({id:doc.id,...doc.data()})
            setStudentDetails(array);
        });
      }, []);
  return (
    <div>
  
  {studentDetails?.map((item , index) => (
     <div className="w-full p-5 text-gray-700" key={index}>
  
  <div className="grid grid-cols-7 gap-4">
    <div className="justify-items-center items-center">
      <img src="../assets/sail.png" alt="pic" className="h-32 w-32" />
    </div>
    <div className="mb-2 text-center w-full col-span-5">
      <div className="mb-1 ">
        <span className="font-bold  text-3xl ">
          BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
        </span>
      </div>
      <div className="grid grid-cols-9 gap-4">
        <div className="mb-1 col-span-5 ml-10">
          <span className="text-xl ">BOKARO STEEL CITY, JHARKHAND</span>
        </div>
        <div className="mb-1 col-span-3">
          <span className="text-xl ">CBSE Affiliation NO.</span>
        </div>
      </div>
      <div className="mb-1 mt-5">
        <span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
          STUDENT ADMISSION FORM - <span>{item.studied}</span>/
            <span>{item.classSection}</span> 
        </span>
      </div>
    </div>
    <div className="justify-items-center items-center">
      <img src="../assets/as_logo.png" alt="pic" className="h-32 w-32" />
    </div>
  </div>
  <div className="w-full mt-5">
    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Form NO.
          </label>
        </div>
        <div className="md:w-2/3">
         {item.formNumber}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            New Admission
          </label>
        </div>
        <div className="md:w-2/3">
        {item.newAdmission}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Admission Date
          </label>
        </div>
        <div className="md:w-3/5">
        {item.admissionDate}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/2">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Admission Number
          </label>
        </div>
        <div className="md:w-2/3">
         {item.admissionNumber}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Student Id
          </label>
        </div>
        <div className="md:w-2/3">
          {item.studentIdNumber}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Category
          </label>
        </div>
        <div className="md:w-3/5">
         {item.category}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Student Type
          </label>
        </div>
        <div className="md:w-3/5">
         {item.studentType}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            RTE
          </label>
        </div>
        <div className="md:w-3/5">
         {item.rte}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Board Type
          </label>
        </div>
        <div className="md:w-3/5">
         {item.boardType}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Stream
          </label>
        </div>
        <div className="md:w-3/5">
         {item.stream}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/2">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Class
          </label>
        </div>
        <div className="md:w-2/3">
          {item.studied}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            classSection
          </label>
        </div>
        <div className="md:w-2/3">
         {item.classSection}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Roll Number
          </label>
        </div>
        <div className="md:w-3/5">
       {item.studentRollNumber}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Name of Pupil
          </label>
        </div>
        <div className="md:w-2/3">
       {item.fullName}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Gender
          </label>
        </div>
        <div className="md:w-2/3">
         {item.gender}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Date of Birth
          </label>
        </div>
        <div className="md:w-3/5">
        {item.dateOfBirth}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Father's Name
          </label>
        </div>
        <div className="md:w-2/3">
        {item.fathersName}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Mother's Name
          </label>
        </div>
        <div className="md:w-2/3">
         {item.mothersName}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Phone Number
          </label>
        </div>
        <div className="md:w-3/5">
        {item.phoneNumber}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-3 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Email-Id
          </label>
        </div>
        <div className="md:w-2/3">
         {item.emailId}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Blood Group
          </label>
        </div>
        <div className="md:w-3/5">
         {item.bloodGroup}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Religion
          </label>
        </div>
        <div className="md:w-3/5">
         {item.religion}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div className="md:flex md:items-center mb-6">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Aadhaar Number
          </label>
        </div>
        <div className="md:w-2/3">
        {item.aadhaarNumber}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Nationality
          </label>
        </div>
        <div className="md:w-3/5">
         {item.nationality}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div className="w-full p-5">
        <div className="mb-2 text-left ">
          <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
            Permanent Address
          </span>
        </div>
        <div className="w-full">
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Address Line 1:
              </label>
            </div>
            <div className="md:w-2/3">
            {item.permanentAddressLine}
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Area/Road/Locality:
              </label>
            </div>
            <div className="md:w-2/3">
             {item.permanentAreaLocality}
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Apartment
              </label>
            </div>
            <div className="md:w-2/3">
             {item.permanentApartmentHouse}
            </div>
          </div>
          <div className="md:flex md:items-center mb-6">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                State
              </label>
            </div>
            <div className="md:w-2/3">
             {item.permanentState}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-2/5">
                <label
                  className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Zip Code
                </label>
              </div>
              <div className="md:w-3/5">
              {item.permanentZip}
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-2/5">
                <label
                  className="block text-gray-500 font-bold md:text-center mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  City
                </label>
              </div>
              <div className="md:w-3/5">
               {item.permanentCity}
              </div>
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Country
              </label>
            </div>
            <div className="md:w-2/3">
             {item.permanentCountry}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full p-5">
        <div className="mb-2 text-left ">
          <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
            Correspondence Address
          </span>
        </div>
        <div className="w-full">
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Address Line 1:
              </label>
            </div>
            <div className="md:w-2/3">
             {item.correspondenceAddressLine}
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Area/Locality:
              </label>
            </div>
            <div className="md:w-2/3">
             {item.correspondenceAreaLocality}
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center mb-6 ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Apartment
              </label>
            </div>
            <div className="md:w-2/3">
             {item.correspondenceApartment}
            </div>
          </div>
          <div className="md:flex md:items-center mb-6">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                State
              </label>
            </div>
            <div className="md:w-2/3">
             {item.correspondenceState}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-2/5">
                <label
                  className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Zip Code
                </label>
              </div>
              <div className="md:w-3/5">
               {item.correspondenceZip}
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-2/5">
                <label
                  className="block text-gray-500 font-bold md:text-center mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  City
                </label>
              </div>
              <div className="md:w-3/5">
              {item.correspondenceCity}
              </div>
            </div>
          </div>
          <div className=" w-full md:flex  md:items-center ">
            <div className="mb-4 md:w-1/3">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                htmlFor="inline-full-name"
              >
                Country
              </label>
            </div>
            <div className="md:w-2/3">
             {item.correspondenceCountry}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="grid grid-cols-7 gap-4">
      <div className="md:flex md:items-center mb-6 col-span-2">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Physical Type
          </label>
        </div>
        <div className="md:w-3/5">
         {item.physicalType}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 col-span-3 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Student Prev School
          </label>
        </div>
        <div className="md:w-3/5">
         {item.studentPrevSchoolName}
        </div>
      </div>

      <div className="md:flex md:items-center mb-6 col-span-2">
        <div className="md:w-1/2">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Student Prev TC
          </label>
        </div>
        <div className="md:w-1/2">
         {item.studentPrevTc}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-7 gap-4">
      <div className="md:flex md:items-center mb-6 col-span-3">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-left mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Previous TC Number
          </label>
        </div>
        <div className="md:w-3/5">
        {item.studentPrevTcNumber}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 col-span-2 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            SLC
          </label>
        </div>
        <div className="md:w-3/5">
         {item.studentLeavingCertificate}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 col-span-2">
        <div className="md:w-1/2">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Student Admit Class
          </label>
        </div>
        <div className="md:w-1/2">
          {item.studentAdmitClass}
        </div>
      </div>
    </div>

    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            House
          </label>
        </div>
        <div className="md:w-3/5">
         {item.house}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-1/3">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            CSR Tag
          </label>
        </div>
        <div className="md:w-3/5">
         {item.csrTag}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Admission Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.admissionFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.admissionFeeCash}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Anuual Fee
          </label>
        </div>
        <div className="md:w-3/5">
          {item.annualFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.annualFeeCash}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Activity Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.activityFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.activityFeeCash}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Exam Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.examFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.examFeeCash}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Tuition Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.tuitionFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.tuitionFeeCash}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Science Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.scienceFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
         {item.scienceFeeCash}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-2/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Computer Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.computerFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
        {item.computerFeeCash}
        </div>
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-3/5">
          <label
            className="block font-bold md:text-center mb-1 md:mb-0 "
            htmlFor="inline-full-name"
          >
            Session Fee
          </label>
        </div>
        <div className="md:w-3/5">
         {item.sessionFee}
        </div>
      </div>
      <div className="md:flex md:items-center mb-6 ">
        <div className="md:w-full">
        {item.sessionFeeCash}
        </div>
      </div>
    </div>
  </div>
</div>
    ))}
</div>
  )
}

export default StudentDetailsAll